import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/industryManage/index';

const PageComponentName = PageComponent;

export default PageComponentName;
